/** «## Τίτλος» → επικεφαλίδα, «- κείμενο» → λίστα, κενή γραμμή → νέα παράγραφος (κοινό με Admin editor). */
export const parseLegalContent = (content = "") => {
  const blocks = [];
  let para = [];
  const flush = () => { if (para.length) { blocks.push({ type: "p", text: para.join(" ") }); para = []; } };
  content.split(/\r?\n/).forEach((raw) => {
    const line = raw.trim();
    if (!line) return flush();
    if (line.startsWith("## ")) { flush(); blocks.push({ type: "h", text: line.slice(3).trim() }); return; }
    if (/^[-•]\s+/.test(line)) { flush(); blocks.push({ type: "li", text: line.replace(/^[-•]\s+/, "") }); return; }
    para.push(line);
  });
  flush();
  return blocks;
};

export const LegalBlocks = ({ content }) => {
  const out = [];
  let list = null;
  parseLegalContent(content).forEach((b, i) => {
    if (b.type === "li") {
      if (!list) { list = []; out.push(<ul key={`ul-${i}`} className="list-disc pl-5 space-y-1 my-2">{list}</ul>); }
      list.push(<li key={i}>{b.text}</li>);
      return;
    }
    list = null;
    if (b.type === "h") out.push(<h4 key={i} className="font-semibold text-slate-900 mt-4 mb-1">{b.text}</h4>);
    else out.push(<p key={i} className="my-2">{b.text}</p>);
  });
  return <>{out}</>;
};
